import React, { useEffect } from 'react';
import { IState, ReduxMap } from '../../redux/redux';
import { INomination, INominationInfo } from './NominationTypes';
import StoreX, { store } from '../../redux/oldStore';
import { ServerResponse } from '../../utils/Server';
import { toast } from 'react-toastify';
import Button from '../_Core/Button';
import Select from 'react-select';
import { IProjectInfo } from '../_Core/CoreTypes';
import { Selectable } from '../../utils/CommonTypes/CommonTypes';
import Modal from '../Modal/Modal';
import { set } from 'lodash';
import Icon, { IconType } from '../Icon/Icon';
import ProjectDetailsWraper from '../Showcase/projectDetailsWraper';

interface NominationsReviewProps extends IState {}

const StatusOptions = ['Pending', 'Approved', 'Rejected'];

const NominationsReview = (props: NominationsReviewProps) => {
  const [data, setData] = React.useState<INominationInfo>();
  const [projectDic, setProjectDic] = React.useState<Record<number, IProjectInfo>>({});
  const [filterNomination, setFilterNomination] = React.useState<INomination[]>([]);
  const [searchOptions, setSearchOptions] = React.useState<Selectable[]>([]);
  const [selectedOptions, setSelectedOptions] = React.useState<Selectable[]>([]);
  const [modalOpen, setModalOpen] = React.useState<boolean>(false);
  const [selectedNomination, setSelectedNomination] = React.useState<INomination>();
  const [selectedProject, setSelectedProject] = React.useState<IProjectInfo>();
  const [selectedAward, setSelectedAward] = React.useState<string>();
  const [showShowcase, setShowShowcase] = React.useState<boolean>(false);

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (data) {
      //build search options here...
      let options: Selectable[] = [];

      let subOptions: Selectable[] = [];
      data.categories.forEach((c) => {
        subOptions.push({ value: `cate:${c.id}`, label: c.name });
      });
      options.push({ label: 'Categories', value: '', options: subOptions });

      subOptions = [];
      data.specialAwards.forEach((c) => {
        subOptions.push({ value: `award:${c.id}`, label: c.name });
      });
      options.push({ label: 'Special Awards', value: '', options: subOptions });

      subOptions = [];
      data.projects.forEach((c) => {
        subOptions.push({ value: `proj:${c.id}`, label: c.title });
      });
      options.push({ label: 'Projects', value: '', options: subOptions });

      subOptions = [];
      StatusOptions.forEach((c) => {
        subOptions.push({ value: `status:${c}`, label: c });
      });
      options.push({ label: 'Status', value: '', options: subOptions });

      setSearchOptions(options);
    }
  }, [data]);

  useEffect(() => {
    if (data) {
      //Apply searches here...
      setFilterNomination(data.nominations);
    }
  }, [data]);

  useEffect(() => {
    if (data) {
      let filter = data.nominations;
      selectedOptions.forEach((x) => {
        let parts = x.value.toString().split(':');
        let type = parts[0];
        let idStr = parts[1];
        let id = parseInt(parts[1]);
        if (type === 'cate') {
          filter = filter.filter((n) => {
            let project = projectDic[n.ProjectId];
            return project && project.categoryId === id;
          });
        } else if (type === 'award') {
          filter = filter.filter((n) => {
            return n && n.SpecialAwardId === id;
          });
        } else if (type === 'proj') {
          filter = filter.filter((n) => {
            return n && n.ProjectId === id;
          });
        } else if (type === 'status') {
          filter = filter.filter((n) => {
            return n && n.ReviewStatus === idStr;
          });
        }
      });
      setFilterNomination(filter);
    }
  }, [selectedOptions]);

  const saveReview = () => {
    if (!selectedNomination) {
      return;
    }
    store.server.postApi<ServerResponse<INomination>>('../SpecialAwardNominations/SaveNominationReview', selectedNomination).then((x) => {
      if (x.Success) {
        toast.success('Nomination Reviewed');
        setModalOpen(false);
        init();
      } else {
        console.error(x);
        toast.error(x.Message, { autoClose: false });
      }
    });
  };

  const init = () => {
    store.server.getApi<ServerResponse<INominationInfo>>('../SpecialAwardNominations/Nominations').then((x) => {
      if (x.Success) {
        setData(x.Value);
        let dic: Record<number, IProjectInfo> = {};
        x.Value.projects.forEach((p) => {
          dic[p.id] = p;
        });
        setProjectDic(dic);
      } else {
        console.error(x);
        toast.error(x.Message, { autoClose: false });
      }
    });
  };

  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'Pending':
        return <div className='label label-warning'><Icon type={IconType.pending} /> Pending</div>;
      case 'Approved':
        return <div className='label label-success'><Icon type={IconType.agree} /> Approved</div>;
      case 'Rejected':
        return <div className='label label-danger'><Icon type={IconType.cancel} /> Rejected</div>;
      default:
        return null;
    }
  };
  return (
    <>
      <div>
        <div className="flex-between">
          <h3>Review Nominations</h3>
          <Button onClick={init} text="Refresh" type="refresh" />
        </div>
        <div className="search-bar flex-between">
          <div className="flex">
            <label className="control-label" htmlFor="search-it">
              Search {'  '}
            </label>
            <div className="bumper-left">
              <Select
                options={searchOptions}
                id="search-it"
                onChange={(x: any) => {
                  setSelectedOptions(x);
                }}
                value={selectedOptions}
                isMulti={true}
                autoFocus={true}
                placeholder="Search by Award, project, or nomination status"
              />
            </div>
          </div>
          <div>Show Stats IE Number of Nominations</div>
        </div>
        {data &&
          filterNomination.map((x, i) => {
            let award = data.awardsDic[x.SpecialAwardId];
            let project = projectDic[x.ProjectId];
            if (!project) {
              return null;
            }
            //let category = data.cateDic[project.categoryId];
            return (
              <div key={i} className="nomination-card">
                <div className="award-name">{award}</div>
                <div className="flex-between">
                  <div className="flex">
                    <div className="nomination-status">
                      {getStatusIcon(x.ReviewStatus)}
                      <div>{x.ReviewScore && <>{x.ReviewScore}</>}</div>
                      <br/>
                      <Button
                        type="edit"
                        text="Review"
                        extraSmall={true}
                        onClick={() => {
                          setSelectedNomination(x);
                          setSelectedProject(project);
                          setSelectedAward(award);
                          setModalOpen(true);
                        }}
                      />
                    </div>
                    <div>
                      <div className="project-id">{project.projectId}
                        {"  "}
                        <Button type='details' extraSmall={true} iconOnly={true} onClick={() => {
                          setSelectedProject(project);
                          setShowShowcase(true);
                        }} />
                      </div>
                      <div className="nomination-type">Type: {x.NominationType}</div>
                      <div className="nomination-category">{project.categoryName}</div>
                    </div>
                  </div>
                  <div className="title" dangerouslySetInnerHTML={{ __html: project.title }}></div>
                </div>
              </div>
            );
          })}
      </div>
      {modalOpen && (
        <Modal setModalOpen={setModalOpen} title={`Nomination for ${selectedAward}`} size="xl">
          <div className="form-horizontal">
            <div className="form-group">
              <label className="control-label col-sm-3" htmlFor="project-id">
                Project
              </label>
              <div className="col-sm-8">
                <input id="project-id" type="text" className="form-control" value={selectedProject?.projectId} readOnly={true} />
              </div>
            </div>
            <div className="form-group">
              <label className="control-label col-sm-3" htmlFor="project-title">
                Title
              </label>
              <div className="col-sm-8">
                <input id="project-title" type="text" className="form-control" value={selectedProject?.title} readOnly={true} />
              </div>
            </div>
            <div className="form-group">
              <label className="control-label col-sm-3" htmlFor="nomination-type">
                Nomination Type
              </label>
              <div className="col-sm-8">
                <input id="nomination-type" type="text" className="form-control" value={selectedNomination?.NominationType} readOnly={true} />
              </div>
            </div>
            <div className="form-group">
              <label className="control-label col-sm-3" htmlFor="nomination-reason">
                Reason
              </label>
              <div className="col-sm-8">
                <textarea id="nomination-reason" className="form-control" rows={6} value={selectedNomination?.Reason} readOnly={true} />
              </div>
            </div>
            <div className="form-group">
              <label className="control-label col-sm-3" htmlFor="nomination-review-notes">
                Review Notes
              </label>
              <div className="col-sm-8">
                <textarea
                  id="nomination-review-notes"
                  className="form-control"
                  rows={6}
                  value={selectedNomination?.ReviewNotes}
                  onChange={(x) => {
                    let newNom = { ...selectedNomination };
                    newNom.ReviewNotes = x.target.value;
                    setSelectedNomination(newNom);
                  }}
                />
              </div>
            </div>
            <div className="form-group">
              <label className="control-label col-sm-3" htmlFor="nomination-review-status">
                Review Status
              </label>
              <div className="col-sm-8">
                <Select
                  options={StatusOptions.map((x) => {
                    return { value: x, label: x };
                  })}
                  value={{ value: selectedNomination?.ReviewStatus, label: selectedNomination?.ReviewStatus }}
                  onChange={(x: any) => {
                    let newNom = { ...selectedNomination };
                    newNom.ReviewStatus = x.value;
                    setSelectedNomination(newNom);
                  }}
                />
              </div>
            </div>
            <div className="form-group">
              <label className="control-label col-sm-3" htmlFor="nomination-review-score">
                Review Score
              </label>
              <div className="col-sm-8">
                <input
                  id="nomination-review-score"
                  type="number"
                  className="form-control"
                  value={selectedNomination?.ReviewScore}
                  onChange={(x) => {
                    let newNom = { ...selectedNomination };
                    newNom.ReviewScore = x.target.value;
                    setSelectedNomination(newNom);
                  }}
                />
              </div>
            </div>
            <div className="form-group">
              <div className="col-sm-offset-3 col-sm-8">
                <div className='btn-group'>
                <Button text="Save" type="save" onClick={saveReview} />
                
                <Button type='details' text='View  Entry' onClick={() => {                          
                          setShowShowcase(true);
                        }} />
                        </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {showShowcase && selectedProject && <Modal 
        setModalOpen={setShowShowcase} 
        title={"Entry Details"}
        size="xxl">
          <ProjectDetailsWraper ProjectKey={selectedProject.projectKey}  />
          </Modal>}
    </>
  );
};

export default ReduxMap(NominationsReview);
